<template>
  <router-link
    v-for="eqo in eqoList"
    :key="eqo.id"
    :to="{ name: 'EqoPage', params: { id: eqo.id } }"
    class="grid grid-cols-3 gap-2 p-2 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-sm"
  >
    <div class="flex items-center gap-2">
      <component :is="getEqoIcon(eqo.status)" class="w-3 h-3" :class="getEqoColor(eqo.status)" :title="eqo.status" />
      <span class="text-sm truncate">{{ eqo.number }}</span>
      <i
        v-if="eqo.deletedAt"
        class="pi pi-trash text-red-500 text-xs"
        v-tooltip.bottom="eqo.archiveReason ? `Archived: ${eqo.archiveReason}` : 'Archived'"
      ></i>
    </div>
    <div class="flex items-center gap-2">
      <span class="text-sm">{{ eqo.partsCount }}</span>
      <Image
        :src="getFlagUrl(eqo.customer.country)"
        :alt="eqo.customer.country"
        class="w-4 h-3"
        image-class="rounded-sm"
      />
      <span class="text-sm truncate">{{ eqo.customer.name }}</span>
    </div>
    <span class="text-sm truncate">{{ eqo?.parts[0]?.number ?? '-' }}</span>
  </router-link>
</template>

<script setup>
import { Image } from 'primevue'
import { getEqoColor, getEqoIcon } from '@/utils/eqo'
import { getFlagUrl } from '@/utils/helpers'

defineProps({
  eqoList: { type: Array, default: () => [] },
})
</script>
